import { useEffect, useRef, useState } from "react";
import DOMPurify from "dompurify";
import { useSelector } from "react-redux";
import { selectNotebooks } from "../../ducks/data/notebooks/selectors";
import { useAppDispatch } from "../../redux-store";
import { loadNotebooks } from "../../ducks/data/notebooks";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

const NotebookPage = () => {
  const { t } = useTranslation("translation");
  const [notebookPageContent, setNotebookPageContent] = useState<string>("");
  const [selectedNotebookId, setSelectedNotebookId] = useState<string | null>(
    null
  );
  const dispatch = useAppDispatch();
  const isInitialRenderRef = useRef(true);
  const notebooks = useSelector(selectNotebooks);

  useEffect(() => {
    dispatch(loadNotebooks());
  }, [dispatch]);

  useEffect(() => {
    if (!isInitialRenderRef.current) {
      return;
    }
    if (!selectedNotebookId && notebooks.length) {
      isInitialRenderRef.current = true;
      setSelectedNotebookId(notebooks[0]?.id || "");
      setNotebookPageContent(DOMPurify.sanitize(notebooks[0]?.content || ""));
    }
  }, [notebooks]);

  return (
    <div>
      {notebooks.length > 1 ? (
        <div>
          <Autocomplete
            value={
              notebooks
                .map((n) => ({ id: n.id, label: n.name }))
                .find((n) => n.id === selectedNotebookId) || null
            }
            options={notebooks.map((n) => ({
              id: n.id,
              label: n.name,
            }))}
            onChange={(_, value) => {
              if (value) {
                setSelectedNotebookId(value.id);
                const content = notebooks.find(
                  (notebook) => notebook.id === value.id
                )?.content;
                setNotebookPageContent(DOMPurify.sanitize(content || ""));
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("drawer.menuItem_NOTEBOOK")}
                variant="outlined"
              />
            )}
          />
          <br />
        </div>
      ) : null}
      <div dangerouslySetInnerHTML={{ __html: notebookPageContent }}></div>
    </div>
  );
};

export default NotebookPage;
